module.exports = __webpack_public_path__ + "img/Blog-Image@3x.2ee25833.png";